export const GET_TODOS = 'todos/GET_TODOS'
export const GET_TODO = 'todos/GET_TODO'
export const ADD_TODOS = 'todos/ADD_TODOS'
export const EDIT_TODOS = 'todos/EDIT_TODOS'
export const DELETE_TODOS = 'todos/DELETE_TODOS'
export const START_LOADING_TODOS = 'todos/START_LOADING_TODOS'
export const STOP_LOADING_TODOS = 'todos/STOP_LOADING_TODOS'
export const TODOS_LOAD_FAILED = 'todos/TODOS_LOAD_FAILED'
